var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "780px", width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Smart Offer (" + _vm._s(this.rules.name) + ")"),
              ]),
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-tabs",
                {
                  attrs: {
                    left: "",
                    "background-color": "blue-grey lighten-5",
                  },
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c("v-tab", { key: "tab_general" }, [_vm._v("GENERAL")]),
                  _c("v-tab", { key: "tab_bundles" }, [_vm._v("BUNDLES")]),
                ],
                1
              ),
              _c(
                "v-tabs-items",
                {
                  model: {
                    value: _vm.tab,
                    callback: function ($$v) {
                      _vm.tab = $$v
                    },
                    expression: "tab",
                  },
                },
                [
                  _c(
                    "v-tab-item",
                    { key: "tab_general" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c(
                            "v-row",
                            { staticClass: "mt-2", attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "9", sm: "9" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      disabled: "",
                                      label: "UID:",
                                      "hide-details": "",
                                      outlined: "",
                                      dense: "",
                                    },
                                    model: {
                                      value: _vm.model.uid,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "uid",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "model.uid",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "3", md: "3" } },
                                [
                                  _c("v-switch", {
                                    staticClass: "mt-1",
                                    attrs: {
                                      label: "Remote Assets",
                                      color: "success",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.remoteAssets,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "remoteAssets", $$v)
                                      },
                                      expression: "model.remoteAssets",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4", sm: "4" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "ascii-only",
                                        rawName: "v-ascii-only",
                                      },
                                    ],
                                    attrs: { label: "Name:" },
                                    model: {
                                      value: _vm.model.name,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "name",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "model.name",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4", sm: "4" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "ascii-only",
                                        rawName: "v-ascii-only",
                                      },
                                    ],
                                    attrs: { label: "Key:" },
                                    model: {
                                      value: _vm.model.key,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "key",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "model.key",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "4", md: "4" } },
                                [
                                  _c("v-autocomplete", {
                                    attrs: {
                                      items: _vm.itemsShowOnLaunch,
                                      "item-text": "name",
                                      "item-value": "value",
                                      label: "Show on launch",
                                    },
                                    model: {
                                      value: _vm.model.showOnLaunch,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.model, "showOnLaunch", $$v)
                                      },
                                      expression: "model.showOnLaunch",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "4", sm: "4" } },
                                [
                                  _c("v-text-field", {
                                    directives: [
                                      {
                                        name: "ascii-only",
                                        rawName: "v-ascii-only",
                                      },
                                    ],
                                    attrs: { label: "Patch key:" },
                                    model: {
                                      value: _vm.model.patchKey,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "patchKey",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "model.patchKey",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", md: "3", sm: "3" } },
                                [
                                  _c("r-smart-offer-kind", {
                                    attrs: {
                                      model: _vm.model.kind,
                                      label: "Group",
                                    },
                                    on: {
                                      "update:model": function ($event) {
                                        return _vm.$set(
                                          _vm.model,
                                          "kind",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Delay Show",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.delayShow,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "delayShow",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.delayShow",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Quantity",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.quantity,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "quantity",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.quantity",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "3", md: "3" } },
                                [
                                  _c("r-smart-offer-button-place", {
                                    attrs: {
                                      model: _vm.model.buttonPlace,
                                      label: "Button Place",
                                    },
                                    on: {
                                      "update:model": function ($event) {
                                        return _vm.$set(
                                          _vm.model,
                                          "buttonPlace",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Button Priority",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.buttonPriority,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "buttonPriority",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.buttonPriority",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Button Timeout",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.buttonTimeout,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "buttonTimeout",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.buttonTimeout",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            { staticClass: "mb-4", attrs: { dense: "" } },
                            [
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        label: "Launch Delay",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model.launchDelay,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "launchDelay",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "model.launchDelay",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "Delay after the map loads before the offer becomes available."
                                        ),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c(
                                    "v-tooltip",
                                    {
                                      attrs: { top: "" },
                                      scopedSlots: _vm._u([
                                        {
                                          key: "activator",
                                          fn: function ({ on, attrs }) {
                                            return [
                                              _c(
                                                "v-text-field",
                                                _vm._g(
                                                  _vm._b(
                                                    {
                                                      attrs: {
                                                        label: "Duration",
                                                        "hide-details": "",
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.model.duration,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.model,
                                                            "duration",
                                                            _vm._n($$v)
                                                          )
                                                        },
                                                        expression:
                                                          "model.duration",
                                                      },
                                                    },
                                                    "v-text-field",
                                                    attrs,
                                                    false
                                                  ),
                                                  on
                                                )
                                              ),
                                            ]
                                          },
                                        },
                                      ]),
                                    },
                                    [
                                      _c("dl", [
                                        _c("dt", [_vm._v(" n: DEFAULT")]),
                                        _c("dt", [_vm._v(" 0: ONE_TIME")]),
                                        _c("dt", [_vm._v("-1: UNLIMITED")]),
                                      ]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Cooldown",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.cooldown,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "cooldown",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.cooldown",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Cooldown Passed",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.cooldownPassed,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "cooldownPassed",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.cooldownPassed",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Reset Time",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.resetTime,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "resetTime",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.resetTime",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "2", md: "2" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: "Lastwave",
                                      "hide-details": "",
                                    },
                                    model: {
                                      value: _vm.model.lastwave,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.model,
                                          "lastwave",
                                          _vm._n($$v)
                                        )
                                      },
                                      expression: "model.lastwave",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panels",
                            { attrs: { focusable: "" } },
                            [
                              _c(
                                "r-panel",
                                { attrs: { title: "Advanced settings" } },
                                [
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mt-2 mb-4",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "3",
                                            md: "3",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Launch Delay Offset",
                                                                "hide-details":
                                                                  "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model
                                                                    .launchDelayOffset,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model,
                                                                      "launchDelayOffset",
                                                                      _vm._n(
                                                                        $$v
                                                                      )
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model.launchDelayOffset",
                                                              },
                                                            },
                                                            "v-text-field",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "A random value in the range [0..n] is added to the LaunchDelay parameter"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "3",
                                            md: "3",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Cooldown Offset",
                                                                "hide-details":
                                                                  "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model
                                                                    .cooldownOffset,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model,
                                                                      "cooldownOffset",
                                                                      _vm._n(
                                                                        $$v
                                                                      )
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model.cooldownOffset",
                                                              },
                                                            },
                                                            "v-text-field",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "A random value in the range [0..n] is added to the Cooldown parameter"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "3",
                                            md: "3",
                                          },
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u([
                                                {
                                                  key: "activator",
                                                  fn: function ({ on, attrs }) {
                                                    return [
                                                      _c(
                                                        "v-text-field",
                                                        _vm._g(
                                                          _vm._b(
                                                            {
                                                              attrs: {
                                                                label:
                                                                  "Cooldown Passed Offset",
                                                                "hide-details":
                                                                  "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.model
                                                                    .cooldownPassedOffset,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.model,
                                                                      "cooldownPassedOffset",
                                                                      _vm._n(
                                                                        $$v
                                                                      )
                                                                    )
                                                                  },
                                                                expression:
                                                                  "model.cooldownPassedOffset",
                                                              },
                                                            },
                                                            "v-text-field",
                                                            attrs,
                                                            false
                                                          ),
                                                          on
                                                        )
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ]),
                                            },
                                            [
                                              _c("div", [
                                                _vm._v(
                                                  "A random value in the range [0..n] is added to the CooldownPassed parameter"
                                                ),
                                              ]),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "3",
                                            md: "3",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Extend Duration",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.model.extendDuration,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "extendDuration",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "model.extendDuration",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "3",
                                            md: "3",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "Extend Pending",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.model.extendPending,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "extendPending",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression: "model.extendPending",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            md: "3",
                                            sm: "3",
                                          },
                                        },
                                        [
                                          _c("v-text-field", {
                                            attrs: {
                                              label: "AutoOpen Cooldown",
                                              "hide-details": "",
                                            },
                                            model: {
                                              value: _vm.model.autoOpenCooldown,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.model,
                                                  "autoOpenCooldown",
                                                  _vm._n($$v)
                                                )
                                              },
                                              expression:
                                                "model.autoOpenCooldown",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-row",
                                    {
                                      staticClass: "mb-2",
                                      attrs: { dense: "" },
                                    },
                                    [
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "6",
                                          },
                                        },
                                        [
                                          _c("r-talk-dropdown", {
                                            attrs: {
                                              model: _vm.model.talkActive,
                                              clearable: true,
                                              label: "Talk Active",
                                            },
                                            on: {
                                              "update:model": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.model,
                                                  "talkActive",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                      _c(
                                        "v-col",
                                        {
                                          attrs: {
                                            cols: "12",
                                            sm: "6",
                                            md: "6",
                                          },
                                        },
                                        [
                                          _c("r-talk-dropdown", {
                                            attrs: {
                                              model: _vm.model.talkClosed,
                                              clearable: true,
                                              label: "Talk Closed",
                                            },
                                            on: {
                                              "update:model": function (
                                                $event
                                              ) {
                                                return _vm.$set(
                                                  _vm.model,
                                                  "talkClosed",
                                                  $event
                                                )
                                              },
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("r-guard-time-panel", {
                                attrs: {
                                  model: _vm.model.guardTime,
                                  title: "Guard Time",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "guardTime",
                                      $event
                                    )
                                  },
                                },
                              }),
                              _c("r-reminder-panel", {
                                attrs: {
                                  model: _vm.model.reminder,
                                  title: "Reminders",
                                },
                                on: {
                                  "update:model": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "reminder",
                                      $event
                                    )
                                  },
                                },
                              }),
                              _c("r-smart-offer-skin-panel", {
                                attrs: {
                                  items: _vm.model.skins,
                                  title: "Skins",
                                },
                                on: {
                                  "update:items": function ($event) {
                                    return _vm.$set(_vm.model, "skins", $event)
                                  },
                                },
                              }),
                              _c("r-trigger-panel", {
                                attrs: {
                                  items: _vm.model.triggersAvailable,
                                  title: "Triggers - Available",
                                },
                                on: {
                                  "update:items": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "triggersAvailable",
                                      $event
                                    )
                                  },
                                },
                              }),
                              _c("r-trigger-panel", {
                                attrs: {
                                  items: _vm.model.triggersComplete,
                                  title: "Triggers - Complete",
                                },
                                on: {
                                  "update:items": function ($event) {
                                    return _vm.$set(
                                      _vm.model,
                                      "triggersComplete",
                                      $event
                                    )
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "v-expansion-panels",
                            [
                              _c(
                                "r-panel",
                                { attrs: { title: "Map Group" } },
                                [
                                  _c("r-map-group-dropdown", {
                                    attrs: { model: _vm.model.mapGroup },
                                    on: {
                                      "update:model": function ($event) {
                                        return _vm.$set(
                                          _vm.model,
                                          "mapGroup",
                                          $event
                                        )
                                      },
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "v-tab-item",
                    { key: "tab_bundles" },
                    [
                      _c(
                        "v-col",
                        { attrs: { cols: "12" } },
                        [
                          _c("r-smart-offer-bundle-table", {
                            attrs: { items: _vm.model.bundles, title: "List" },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
          _c("r-preview-dialog", { ref: "preview-dialog" }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }